import { createGlobalStyle } from './styled-components';

export const GlobalStyle = createGlobalStyle`
    @import url('https://fonts.googleapis.com/css?family=Nunito|Open+Sans|Roboto:100,400,500');

    div.OT_publisher .OT_edge-bar-item.OT_mode-off, .OT_subscriber .OT_edge-bar-item.OT_mode-off, .OT_publisher .OT_edge-bar-item.OT_mode-auto, .OT_subscriber .OT_edge-bar-item.OT_mode-auto, .OT_publisher .OT_edge-bar-item.OT_mode-mini-auto, .OT_subscriber .OT_edge-bar-item.OT_mode-mini-auto {
        display: none !important;
    }
    
    h2 {
        /* color: $primary; */
    }

    iframe {
        width: 100%;
    }

    *  {
        -webkit-overflow-scrolling: touch;
    }

    button:focus {
        outline: 0;
    }

    #root {
        overflow-x: hidden;
    }

    .fade-enter {
        opacity: 0;
        z-index: 1;
    }

    .fade-enter.fade-enter-active {
        opacity: 1;
        transition: opacity 250ms ease-in;
    }

    .OTPublisherContainer {
        width: 100% !important;
        height: 100% !important;
    }

    button {
        cursor: pointer;
    }

    button:disabled {
        cursor: default;
    }

    html {
        font-size: 62.5%;
        margin: 0;
        padding: 0;
        height: 100vh;
        width: 100vw;
        overflow: hidden;
    }

    body {
        font-family: Helvetica, Arial, sans-serif;
        font-size: $m-size;
        color: $dark-grey;
        line-height: 1.6;
        margin: 0;
        padding: 0;
        height: 100vh;
        width: 100vw;
        overflow: scroll;
    }

    /* ul {
        list-style: none;
    } */

    .strengthIndicator {
        top: calc(-2rem - 18px);
        position: relative;
        box-sizing: border-box;
        left: 15px;
        transition: all 0.5s ease;
        width: 1%;

    }
    .strengthIndicator:before {
        top: calc(-3rem - 5px);
        position: absolute;
        box-sizing: border-box;
        left: 1px;
        border: 2px solid red;
        width: calc(100% - 2px);
    }
    .strengthIndicator.white {
        border: 2px solid white;
        width: calc( 2% - 2px);
    }
    .strengthIndicator.red + div > div > input {
        border: 1px solid rgba(255,0,0,0.1);
    }
    .strengthIndicator.red {
        border: 2px solid red;
        width: calc( 20% - 2px);
    }
    .strengthIndicator.red + span {
        color: red;
        top: -2rem;
        left: 15px;
        position: relative;
        margin-bottom: 2rem;
    }

    .strengthIndicator.orange + div > div > input {
        border: 1px solid rgba(255,165,0,0.1);
    }
    .strengthIndicator.orange {
        border: 2px solid orange;
        width: calc( 40% - 2px);
    }
    .strengthIndicator.orange + span {
        color: orange;
        top: -2rem;
        left: 15px;
        position: relative;
        margin-bottom: 2rem;
        }

    .strengthIndicator.yellow + div > div > input {
        border: 1px solid rgba(255,255,0,0.1);
    }
    .strengthIndicator.yellow {
        border: 2px solid #FFD500;
        width: calc( 60% - 2px);
    }
    .strengthIndicator.yellow + span {
        color: #E1BF01;
        top: -2rem;
        left: 15px;
        position: relative;
        margin-bottom: 2rem;
        }

    .strengthIndicator.yellow-green + div > div > input {
        border: 1px solid rgba(154,205,50,0.1);
    }
    .strengthIndicator.yellow-green {
        border: 2px solid #00D000;
        width: calc( 80% - 2px);
    }
    .strengthIndicator.yellow-green + span {
        color: #00D000;
        top: -2rem;
        left: 15px;
        position: relative;
        margin-bottom: 2rem;
    }


    .strengthIndicator.green + div > div > input {
        border: 1px solid rgba(0,255,0,0.1);
    }
    .strengthIndicator.green {
        border: 2px solid #00D000;
        width: calc( 100% - 15px);
    }
    .strengthIndicator.green + span {
        color: #00D000;
        top: -2rem;
        left: 15px;
        position: relative;
        margin-bottom: 2rem;
    }

    div label {
        margin-top: 1rem;
    }
`;



// WEBPACK FOOTER //
// ./src/globalStyles.ts